import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { compose, lifecycle, withState } from 'recompose'
import { Breadcrumb } from 'semantic-ui-react'
import CreateStep from './CreateStep'
import SelectCategory from './Category'
import GeneralDetail from './GeneralDetail'
import SelectPrItems from './AddItem'
import Attachment from './Attachment'
import Summary from './Summary'
import { getPrMenus } from 'ducks/purchaseRequisition'
import { MainBodyContent, CustomButton } from 'components'
import { ProcurementContainer, ProcurementBody } from '../../styled'
import { purchaseRequisitionPath } from '../../../'
import { getUnits, getCurrencies, getPrTypes, getPrCategories, getMaterialGroups, 
  getBudgetTypes, getAccountAssignments, getPurchasingOrgs,
  getPlants, getStorageLocations, getCompanies, getCustomers, getAssets } from 'ducks/options'
import { clearOtherProject } from 'ducks/goa'
import r from 'reactotron-react-js'

const CreatePurchaseRequisition = (props) => {
  const { history, formStep, setFormStep, maxStep, setMaxStep, subCategory } = props

  const onChangeForm = (formIndex) => {
    setFormStep(formIndex)
    window.scrollTo(0, 0)
  }

  return (
    <MainBodyContent headerTitle='Purchase Requisition - Create'
      accessoriesHeader={
        <div style={{display:'flex'}}>
          <CustomButton 
            onClick={() => {
              props.history.push(purchaseRequisitionPath)
              props.clearOtherProject()
            }}
            icon='close'
            btnColor='red'
            title='Cancel'/>
          </div>
        }
        breadcrumbs={
          <Breadcrumb 
            icon='right angle' 
            sections={
              formStep > 1 && subCategory && subCategory.nameEn ? 
              [
                { key: 'PR', content: 'Purchase Requisition', link: true, onClick: () => history.push(purchaseRequisitionPath) },
                { key: 'PRCreate', content: 'Create', active: false },
                { key: 'PRCreateSubCategory', content: subCategory.nameEn, active: true },
              ] :
              [
                { key: 'PR', content: 'Purchase Requisition', link: true, onClick: () => history.push(purchaseRequisitionPath) },
                { key: 'PRCreate', content: 'Create', active: true }
              ]
            }
          />
        }
      >
      <ProcurementContainer>
        <ProcurementBody>
          <CreateStep activeStep={formStep - 1} setFormStep={onChangeForm} maxStep={maxStep} />
          {/* <div style={{ display: formStep === 1 ? 'flex' : 'none', width: '100%' }}>
            <SelectCategory onSubmit={() => onChangeForm(2)} formStep={formStep} setFormStep={onChangeForm} history={history} />
          </div>
          <div style={{ display: formStep === 2 ? 'flex' : 'none', width: '100%' }}>
            <GeneralDetail onSubmit={() => onChangeForm(3)} formStep={formStep} setFormStep={onChangeForm} setMaxStep={setMaxStep} history={history} />
          </div>
          <div style={{ display: formStep === 3 ? 'flex' : 'none', width: '100%' }}>
            <SelectPrItems onSubmit={() => onChangeForm(4)} formStep={formStep} setFormStep={onChangeForm} setMaxStep={setMaxStep} history={history} />
          </div>
          <div style={{ display: formStep === 4 ? 'flex' : 'none', width: '100%' }}>
            <Attachment onSubmit={() => onChangeForm(5)} formStep={formStep} setFormStep={onChangeForm} history={history} />
          </div>
          <div style={{ display: formStep === 5 ? 'flex' : 'none', width: '100%' }}>
            <Summary formStep={formStep} setFormStep={onChangeForm} history={history} />
          </div> */}
          {formStep === 1 ? <SelectCategory style={{ display: formStep === 1 ? 'flex' : 'none' }} onSubmit={() => onChangeForm(2)} formStep={formStep} setFormStep={onChangeForm} history={history} /> : null}
          {formStep === 2 ? <GeneralDetail onSubmit={() => onChangeForm(3)} formStep={formStep} setFormStep={onChangeForm} setMaxStep={setMaxStep} history={history} /> : null}
          {formStep === 3 ? <SelectPrItems onSubmit={() => onChangeForm(4)} formStep={formStep} setFormStep={onChangeForm} setMaxStep={setMaxStep} history={history} /> : null}
          {formStep === 4 ? <Attachment onSubmit={() => onChangeForm(5)} formStep={formStep} setFormStep={onChangeForm} history={history} /> : null}
          {formStep === 5 ? <Summary formStep={formStep} setFormStep={onChangeForm} history={history} /> : null}
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return({
    menus: state.pr.menus,
    subCategory: state.pr.subCategory,
    companies: state.options.companies.data,
    unitOptions: state.options.units.data,
    currencyOptions: state.options.currencies.data,
    prTypes: state.options.prTypes.data,
    prCategories: state.options.prCategories.data,
    materialGroups: state.options.materialGroups.data,
    budgetTypes: state.options.budgetTypes.data,
    accountAssignments: state.options.accountAssignments.data,
    purchasingOrgs: state.options.purchasingOrgs.data,
    plants: state.options.plants.data,
    storageLocations: state.options.storageLocations.data,
    wbsElements: state.options.wbsElements.data,
    customers: state.options.customers.data,
    assets: state.options.assets.data,
  })
}

const mapDispatchToProps = {
  getPrMenus,
  getUnits,
  getCurrencies,
  getPrTypes,
  getPrCategories,
  getMaterialGroups,
  getBudgetTypes,
  getAccountAssignments,
  getPurchasingOrgs,
  getPlants,
  getStorageLocations,
  getCompanies,
  getCustomers,
  getAssets,
  clearOtherProject
}

const enhance = compose(
  withState('formStep', 'setFormStep', 1),
  withState('maxStep', 'setMaxStep', 1),
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formCreatePR',
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.menus === undefined || this.props.menus.length === 0) {
        this.props.getPrMenus()
      }

      if (this.props.unitOptions.length === 0) {
        this.props.getUnits()
      }

      if (this.props.currencyOptions.length === 0) {
        this.props.getCurrencies()
      }

      if (this.props.prTypes.length === 0) {
        this.props.getPrTypes()
      }

      if (this.props.prCategories.length === 0) {
        this.props.getPrCategories()
      }

      if (this.props.materialGroups.length === 0) {
        this.props.getMaterialGroups()
      }

      if (this.props.budgetTypes.length === 0) {
        this.props.getBudgetTypes()
      }

      if (this.props.accountAssignments.length === 0) {
        this.props.getAccountAssignments()
      }

      if (this.props.purchasingOrgs.length === 0) {
        this.props.getPurchasingOrgs()
      }

      if (this.props.plants.length === 0) {
        this.props.getPlants()
      }

      if (this.props.storageLocations.length === 0) {
        this.props.getStorageLocations()
      }

      if (this.props.companies.length === 0) {
        this.props.getCompanies()
      }

      if (this.props.customers.length === 0) {
        this.props.getCustomers()
      }

      if (this.props.assets.length === 0) {
        this.props.getAssets()
      }
    },
    componentDidUpdate(prevProps) {
      const { formStep, maxStep } = this.props
      if (formStep > maxStep) {
        this.props.setMaxStep(formStep)
      }
    },
    componentWillUnmount() {
      this.props.clearOtherProject()
      this.props.reset()
    }
  })
)

export default enhance(CreatePurchaseRequisition)
